import { SpyneTrait } from 'spyne';
import { BreadcrumbView } from 'components/ui-elements/breadcrumb-view.js';
import {pick} from 'ramda';
export class NavBreadcrumbTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = 'breadcrumb$';

    super(context, traitPrefix);
  }

  static breadcrumb$HelloWorld() {
    return 'Hello World';
  }

  static breadcrumb$getBreadcrumbObjs(navLinks) {
    const OMIT_KEYS = new Set(['title', 'href', 'navLevel']);
    const encountered = new Set(); // track which properties we've already assigned
    const bcMap = new Map(); // maps navLevel -> { navLevel, bcProps: [] }

    // Sort by navLevel ascending
    const sortedLinks = [...navLinks].sort((a, b) => a.navLevel - b.navLevel);

    for (const link of sortedLinks) {
      const { navLevel } = link;

      // If we haven't seen this navLevel yet, create an entry
      if (!bcMap.has(navLevel)) {
        bcMap.set(navLevel, { navLevel, bcProps: [] });
      }

      // Check each property in the link object
      for (const [key, value] of Object.entries(link)) {
        // Skip if it's an omitted key or already encountered or empty string
        if (OMIT_KEYS.has(key) || encountered.has(key) || key ==='undefined' || value === '') {
          continue;
        }

        //console.log("KEY IS ",key);

        // Otherwise, mark this key as encountered
        encountered.add(key);
        // Add it to the bcProps array for this navLevel
        bcMap.get(navLevel).bcProps.push(key);
      }
    }

    // Convert the map to an array sorted by navLevel
    return Array.from(bcMap.values()).sort((a, b) => a.navLevel - b.navLevel);
  }

  static breadcrumb$initBreadcrumbs(e) {
    const { navLinks, routeData } = e.payload;

    const breacrumbObjs = this.breadcrumb$getBreadcrumbObjs(navLinks);

    //console.log("BC OBJ ",breacrumbObjs)
    const addBreadcrumbs = (bcObj) => {
      const { bcProps, navLevel } = bcObj;
      this.appendView(
        new BreadcrumbView({
          bcProps,
          navLevel,
          navLinks,
          initPayload: e.payload,
          routeData,
        }),
        '.breadcrumbs-list',
      );
    };

    breacrumbObjs.forEach(addBreadcrumbs);
  }

  static breadcrumb$GetRouteState(payload, props = this.props) {
    const { bcProps, navLevel, navLinks } = props;
    const { paths = [], pathInnermost } = payload;
    const { pageId, topicId, optionId } = payload?.routeData || {};

    const isHome = pageId === 'home';

    // Check if ANY bcProp is present in `paths`
    const isCurrentPath = bcProps.some((prop) => paths.includes(prop));

    // The "selected" prop is whichever bcProp matches pathInnermost
    const isSelectedProp = isCurrentPath && bcProps.includes(pathInnermost);

    // isActiveLevel could mean we're on the correct path and there is a deeper path level available
    const isActiveLevel = isCurrentPath && paths.length > navLevel;

    //console.log("RouteState ",{isHome, isCurrentPath, isSelectedProp, isActiveLevel, bcProps})

    return {
      isHome,
      isCurrentPath,
      isSelectedProp,
      isActiveLevel,
      bcProps,
      navLevel,
      navLinks,
      pageId,
      topicId,
      optionId
    };
  }

  static breadcrumb$GetState(payload, props = this.props) {
    const {
      isHome,
      isCurrentPath,
      isActiveLevel,
      bcProps,
      navLevel,
      navLinks,
    } = this.breadcrumb$GetRouteState(payload, props);

    // Visible if not home and the route includes any of our bcProps
    const isVisible = !isHome && isCurrentPath;
    // Active if it's visible AND the nav level suggests we're not at the deepest route
    const isActive = isVisible && isActiveLevel;

    // If it's not visible, no need to find a navLink
    if (!isVisible) {
      return { isVisible, isActive };
    }

    // Gather all values for the bcProps from the route data
    const bcValues = bcProps.map((prop) => payload?.routeData?.[prop]);

    // Look up the corresponding nav link in navLinks
    const navLink = this.breadcrumb$FindNavLink(
      { bcProps, bcValues, navLevel },
      navLinks,
    );

    return { isVisible, isActive, bcProps, bcValues, navLevel, navLink };
  }

  static breadcrumb$FindNavLink(filterData, navLinks = this.props.navLinks) {
    const { bcProps, bcValues, navLevel } = filterData;
    return navLinks.find((link) => {
      if (link.navLevel !== navLevel) return false;
      // All bcProps must match the corresponding bcValues for this link
      return bcProps.every((prop, i) => link[prop] === bcValues[i]);
    });
  }

  static breadcrumb$getBreadcrumbLinkClass({
    isVisible = true,
    isActive = true,
  } = {}) {
    return [
      'breadcrumb-item', // Base class
      !isVisible && 'breadcrumb-item--hidden', // Hides the link if false
      isActive ? 'breadcrumb-item--active' : 'breadcrumb-item--inactive',
    ]
      .filter(Boolean)
      .join(' ');
  }

  static breadcrumb$UpdateLink(e) {
    const { payload } = e;
    const { paths } = payload;
    const bcState = this.breadcrumb$GetState(payload);
    const { isVisible, isActive, navLink, bcProps } = bcState;
    const breadcrumbClass = this.breadcrumb$getBreadcrumbLinkClass({
      isVisible,
      isActive,
    });

    this.props.el$.setClass(breadcrumbClass);





    const updateLink = () => {
      if (navLink === undefined) {
        return;
      }
      this.props.link$.el.innerText = navLink.title;
      this.props.link$.el.href = navLink.href;

      bcProps.forEach((prop) => {
        const value = payload.routeData?.[prop] || '';
        this.props.linkData[prop] = value;

        const datasetObjProps = pick(paths, navLink);

        //console.log("prop is ",{prop,datasetObjProps, paths, navLink, value}, this.props.linkData)

        for (const [k,v] of Object.entries(datasetObjProps)){
          this.props.link$.el.dataset[k] = v;
        }


        // Optionally, also update the DOM dataset:
        //\\ this.props.link$.el.dataset[prop] = value;

        //console.log("PROP IS ",prop);
      });
    };

   // console.log("THIS ACTIVE IS ",{bcProps,isActive, bcState, payload},this.props.el.innerText);

    if (isActive === false) {
      this.props.el.setAttribute('aria-current', 'page');
      this.props.el.tabIndex = -1;
    } else {
      this.props.el.removeAttribute('aria-current');
      this.props.el.tabIndex = 0;
    }

    if (isVisible) {
      updateLink();
    } else {
      this.props.link$.el.innerText = '';
    }
  }


}
